import { ArrowUpRight, CalendarCheck, MessageSquare, Phone } from "lucide-react";
import { DEALER } from "@/data/dealer";
import { gbp, miles } from "@/lib/inventory";
import { useEnquiry } from "@/components/enquiry/EnquiryProvider";

const Key = ({ label, value }) => (
  <div className="bg-white px-4 py-3">
    <dt className="text-xs font-semibold uppercase tracking-[0.14em] text-steel">{label}</dt>
    <dd className="mt-1 font-semibold text-ink">{value}</dd>
  </div>
);

export const VehicleSummary = ({ v }) => {
  const { openEnquiry } = useEnquiry();
  return (
    <div className="rounded-lg border border-line bg-white p-6 shadow-[0_30px_60px_-45px_rgba(11,13,18,0.6)] lg:p-7" data-testid="vehicle-summary-panel">
      <p className="eyebrow">{v.registration}</p>
      <h1 className="mt-3 font-display text-3xl font-extrabold leading-[1.05] tracking-tight lg:text-[2.1rem]" data-testid="vehicle-title">
        {v.make} {v.model}
      </h1>
      <p className="mt-2 text-steel" data-testid="vehicle-variant">
        {v.variant}
      </p>
      <p className="mt-6 font-display text-4xl font-extrabold tracking-tight lg:text-[2.75rem]" data-testid="vehicle-price">
        {gbp(v.price)}
      </p>
      <dl className="mt-6 grid grid-cols-2 gap-px overflow-hidden rounded-md border border-line bg-line">
        <Key label="Mileage" value={miles(v.mileage)} />
        <Key label="Year" value={v.year} />
        <Key label="Fuel" value={v.fuel} />
        <Key label="Gearbox" value={v.transmission} />
      </dl>
      <div className="mt-6 grid gap-3">
        <button type="button" onClick={() => openEnquiry({ vehicleId: v.id, mode: "enquiry" })} className="btn btn-primary w-full" data-testid="vehicle-enquire-button">
          <MessageSquare aria-hidden="true" /> Enquire About This Car
        </button>
        <button type="button" onClick={() => openEnquiry({ vehicleId: v.id, mode: "viewing" })} className="btn btn-outline w-full" data-testid="vehicle-book-viewing-button">
          <CalendarCheck aria-hidden="true" /> Book a Viewing
        </button>
        <a href={DEALER.phone.href} className="btn btn-dark w-full" data-testid="vehicle-call-link">
          <Phone aria-hidden="true" /> Call {DEALER.phone.display}
        </a>
      </div>
      <a
        href={v.autotraderUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="link-underline mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-ink"
        data-testid="vehicle-autotrader-link"
      >
        View the original AutoTrader advert <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
      </a>
      <p className="mt-5 border-t border-line pt-4 text-sm leading-relaxed text-steel">
        Viewings by appointment only · Open 7 days. Enquiries go straight to the YK Motors inbox.
      </p>
    </div>
  );
};
